export * from './default.service';
import { DefaultServiceRetail } from './default.service';
export const APIS = [DefaultServiceRetail];
